<template>
    <div class="result_box container" v-if="isWx">
        <h1 class="title" v-if="!loading">
            <img v-if="equipment.length || isSearchSucc" src="@/assets/images/title-1.png" alt="">
            <img v-else src="@/assets/images/title-2.png" alt="">
        </h1>
        <div v-if="!loading">
            <div class="result">
                <div class="result_icon">
                    <img v-if="equipment.length || isSearchSucc" src="@/assets/icon/result-success.png" alt="">
                    <img v-else src="@/assets/icon/result-error.png" alt="">
                </div>
                <div class="dot"></div>
                <div class="result_text">
                    <p v-if="equipment.length || isSearchSucc">{{name}}</p>
                    <p v-else>未查询到设备信息</p>
                </div>
            </div>
            <div class="result_img">
                <ul class="equipment" v-if="equipment.length || isSearchSucc">
                    <!-- <li><img src="@/assets/images/equipment.png" alt=""></li> -->
                    <li><img :src="devImg" alt=""></li>
                    <!-- <li v-for="(item, index) in equipment" :key="index"><img :src="item.image" alt=""></li> -->
                </ul>
                <div class="form_btn bot_button">
                    <button type="submit" @click="onBack" class="custom_btn query_btn">重新查询</button>
                    <div class="all">
                        <img src="@/assets/icon/all2.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="form_btn bot_button" :class="{'miniProgram': source == 'wxscan'}">
            <button type="submit" @click="onBack" class="custom_btn query_btn">重新查询</button>
            <div class="all">
                <img src="@/assets/icon/all2.png" alt="">
            </div>
        </div> -->
    </div>
    <div class="result_box result_box2 container" v-else>
        <div class="public_top">
            <p>长按二维码关注公众号</p>
            <p><strong>CBC美容仪器专业委员会</strong></p>
        </div>
        <div class="public_arrow">
                <img src="@/assets/icon/arrow.png" alt="">
        </div>
        <div class="public_wx">
                <img src="@/assets/images/wechat.png" alt="">
        </div>
        <div class="public_tips">
            <p>进入查询通道</p>
        </div>
        <div class="form_btn bot_button" :class="{'miniProgram': source == 'wxscan'}">
            <div class="all">
                <img src="@/assets/icon/all2.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import activity from '@/api/activity'
import wx from 'weixin-js-sdk'
export default {
    name: 'result',
    components: {},
    data() {
        return {
            iid:'', // 设备id
            name:'',
            devImg:'',
            pro_name: '',
            equipment:[],
            loading: true,
            isWx: false,
			from:'',//默认空，如果是扫二维码过来，就是code
			sn:'',//二维码带的sn编号
			isSearchSucc:false,
			source:'',//是否来源于微信小程序扫一扫，如果是，为wxscan
        }
    },
    computed: {
        currentDate() {
            const now = new Date();
            const year = now.getFullYear();
            const month = now.getMonth() + 1;
            const day = now.getDate();
            return { year, month, day };
        }
    },
    created() {
		this.from =  this.$route.query.from;
		this.sn = this.$route.query.sn;
		this.source = this.$route.query.source;
		if(this.from && this.sn){
			this.isWx = this.source == 'wxscan' ? true : false;
			console.log('this.isWxthis.isWxthis.isWx',this.isWx)
			if(this.sn == 'fail'){//如果是失败类型，直接展示失败页面，不再调用接口
				this.isSearchSucc = false;
				this.loading = false
			}else{
				this.getInfoBySn();
			}
			
			if(!this.isWx ){
				document.title = '进入查询通道';
			}
		}else{
            this.iid = this.$route.query.iid;
			this.name = this.$route.query.name;
			this.pro_name = this.$route.query.pro_name;
			this.isWx = true;
			this.onQuery()
		}
		
    },
    mounted () {
        
    },
    methods: {
        onQuery() {
            this.params = {
                iid: this.iid,
                name: this.name,
                pro_name: this.pro_name
            }
            activity.submit(this.params).then((res) => {
                if (res.code === 1) {
                    this.equipment = res.data;
                    this.devImg = res.data?.[0]?.image
                } else {
                    this.$toast(res.msg)
                }
                this.loading = false
            })
        },
        onBack() {
			if(this.source == 'wxscan'){
				wx.miniProgram.redirectTo({
					url: '/pages/scan/scan?type=3' //小程序必须有该目录
				})
			}else{
				this.$router.back()
			}
        },
		
		getInfoBySn() {
			let that = this;
			activity.searchBySn({sn:this.sn}).then((res) => {
				console.log('resresresres',res)
				if(res.data.mes == 1){
					that.isSearchSucc = true;
					that.name = res.data.instrument_name;
                    that.devImg = res.data.pic
					console.log('that.isSearchSucc',that.isSearchSucc)
				}else{
					that.isSearchSucc = false;
				}
				this.loading = false
			})
		}
    }
}
</script>
<style lang="scss" scoped>
	.bot_button.miniProgram{
		padding-bottom: calc(0.6rem + constant(safe-area-inset-bottom));
		padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
	}
    .result_img{
        position: relative;
        min-height: 4.6rem;
        margin: .2rem 0;
        .bot_button{
            position: absolute;
            bottom: auto;
            top: 3.1rem;
            top: 3.6rem;
            padding-bottom: 0;
        }
    }
    .result_box{
        min-height: 100vh;
        padding: 1px 0;
        background: url('~@/assets/bg/result-bg.png') top center #f6f1eb fixed no-repeat;
        background-size: 100% auto;
        padding-bottom: 1rem;
        padding-bottom: cacl(1rem + constant(safe-area-inset-bottom));
        padding-bottom: cacl(1rem + env(safe-area-inset-bottom));
    }
    .result_box2{
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-pack: center;
        -webkit-flex-flow: column wrap;
        -ms-flex-flow: column wrap;
        flex-flow: column wrap;
        align-items: center;
        padding: 0 .3rem;
        background: #f6f1eb;
    }
    .title{
        height: .83rem;
        margin: 1rem 0 .2rem;
        img{
            display: block;
            width: auto;
            height: 100%;
            margin: 0 auto;
        }
    }
    .result{
        width: 7.17rem;
        height: 5.91rem;
        background: url('~@/assets/bg/box-bg.png') center center no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        overflow: hidden;
    }
    .result_icon{
        width: 3.06rem;
        height: 2.67rem;
        margin: .5rem auto 0;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .dot{
        width: 1.07rem;
        height: .11rem;
        margin: 0 auto .3rem;
        background: url('~@/assets/icon/dot.png') center center no-repeat;
        background-size: 100% auto;
    }
    .result_text{
        max-width: 5.7rem;
        font-size: .42rem;
        color: #444444;
        line-height: 1.4;
        text-align: center;
        margin: 0 auto;
    }
    .equipment{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        li{
            flex: 1;
            max-width: 6.9rem;
            text-align: right;
            img{
                display: block;
                width: 100%;
                max-width: 100%;
                width: 5.83rem;
                height: 3.36rem;
                // max-height: 3.1rem;
                object-fit: contain;
                margin: 0 auto;
                border-radius: .2rem;
            }
        }
    }
    .query_btn{
        background-color: #dfb583;
        box-shadow: .08rem .06rem .18rem 10px rgba($color: #6e635a, $alpha: .18);
    }
    .all{
        margin-top: .5rem;
        text-align: center;
        img{
            width: auto;
            height: .19rem;
        }
    }

    .public_top{
        font-size: .4rem;
        color: #5d5751;
        line-height: 1.8;
        text-align: center;
        p{
            margin: .1rem 0;
        }
    }
    .public_arrow{
        width: .37rem;
        height: .41rem;
        margin: .4rem auto;
        img{
            display: block;
            width: 100%;
            height: 100%;
        }
    }
    .public_wx{
        width: 4.1rem;
        height: 4.1rem;
        img{
            display: block;
            width: 100%;
            height: 100%;
        }
    }
    .public_tips{
        font-size: .38rem;
        color: #5d5751;
        line-height: 1.8;
        text-align: center;
        margin: .7rem auto;
        p{
            margin: .1rem 0;
        }
    }
</style>
